import BatchOperation from '@widesk-core/models/batch/BatchOperation';

/**
 * Le message reprend la forme que l'API donne déjà aux erreurs de lot transactionnel
 * (« Élément n°3: … », voir `getTextAndTranslateFromError`), pour que l'utilisateur lise la même
 * chose quel que soit le mode.
 */
const describe = (failed: BatchOperation<any>[]) => {
	const first = failed.at(0);

	if (!first) return 'Le lot a échoué.';

	const detail = first.errorMessage || `code erreur ${first.status}`;
	const text = `Élément n°${first.index + 1}: ${detail}`;

	return failed.length > 1 ? `${text} (et ${failed.length - 1} autre(s) en échec)` : text;
};

/**
 * Échec d'un lot joué SANS transaction : l'API répond alors 207 plutôt qu'une erreur HTTP, donc
 * `BatchManager.run()` jette ceci pour que l'appelant réagisse comme à un `patch()` en échec.
 * `failed` donne les opérations à reprendre, `operations` le lot entier — les autres ont été
 * écrites et leurs models sont à jour.
 */
export default class BatchError extends Error {
	public readonly failed: BatchOperation<any>[];
	public readonly operations: BatchOperation<any>[];

	public constructor(failed: BatchOperation<any>[], operations: BatchOperation<any>[]) {
		super(describe(failed));

		this.name = 'BatchError';
		this.failed = failed;
		this.operations = operations;
	}
}
